export default __webpack_public_path__ + "18cd5755d1baabc1960a26d041fc1f2a.svg";